/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2022-03-30 14:00:27
 * @LastEditors: voanit
 * @LastEditTime: 2022-03-30 16:48:40
 */
import HeaderData from './index.vue'
const Header = {
  install:(Vue) => {
    Vue.component('Header',HeaderData)
  }
}
export default Header



// WEBPACK FOOTER //
// ./src/components/public/HeaderBanner/index.js